import { useUploadFiles } from '#root/queries/media';
import { FILE_KINDS, FILE_REFERENCE_TYPES, type FileKind, type FileReferenceType } from '#root/utils/media';

export interface FileUploadPayload {
  file: File;
  referenceId: string;
  referenceType: FileReferenceType;
  kind: FileKind;
}

export const useFileUpload = () => {
  const uploadFiles = useUploadFiles();

  const uploadImages = async (
    files: FileUploadPayload[]
  ): Promise<string[]> => {
    try {
      const response = await uploadFiles.mutateAsync(files);
      return response.item; 
    } catch (error) {
      console.error('Error in uploadImages:', error);
      throw error;
    }
  };

  return {
    uploadImages
  };
};

export { FILE_KINDS, FILE_REFERENCE_TYPES };
